import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6fb3b322"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "operation-verification" }
const _hoisted_2 = {
  key: 1,
  class: "operation-code-row"
}
const _hoisted_3 = {
  key: 2,
  class: "operation-tip"
}
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("summary", null, "新增备用接收号码（两项功能共用）", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "operation-tip" }, "仅超级管理员可增加，最多5个。请验证超级管理员手机号和新号码；超级管理员手机号不能被替换或取消。", -1))
const _hoisted_6 = { class: "operation-code-row" }
const _hoisted_7 = { class: "operation-code-row" }
const _hoisted_8 = {
  key: 0,
  class: "operation-tip"
}

import {computed,onBeforeUnmount,onMounted,ref,watch} from 'vue'
import {message} from 'ant-design-vue'
import store from '@/store'
import {operationReceiver,sendOperationCode,saveOperationReceiver} from '@/api/platformOperationSecurity'

export default /*#__PURE__*/_defineComponent({
  __name: 'PlatformOperationVerification',
  props: {
    code: { default: '' },
    purpose: { default: 'maintenance' },
    showCode: { type: Boolean, default: true },
    receiverId: { default: 'super' },
    disabled: { type: Boolean, default: false }
  },
  emits: ['update:code','update:receiverId','changed'],
  setup(__props: any, { emit: __emit }) {

const props=__props
const emit=__emit
const receiver=ref<{phone?:string;custom?:boolean;receivers?:Array<{id:string;phone:string;mandatory:boolean}>}>({}),error=ref(''),newPhone=ref(''),currentCode=ref(''),newCode=ref(''),cooldown=ref(0),sending=ref(''),saving=ref(false)
const busy=computed(()=>props.disabled || !!sending.value || saving.value),validNewPhone=computed(()=>/^1[3-9]\d{9}$/.test(newPhone.value))
let generation=0,disposed=false,loadSequence=0
const active=(run:number)=>!disposed && run===generation
async function load(){const run=generation,ticket=++loadSequence;try{const response=await operationReceiver();if(active(run) && ticket===loadSequence){receiver.value=response.data || {};error.value=''}}catch(e:any){if(active(run) && ticket===loadSequence){receiver.value={};error.value=e?.message || '接收号码读取失败，请重试'}}}
async function send(purpose:string){
  if(busy.value || cooldown.value>0)return
  const run=generation;sending.value=purpose
  try{await sendOperationCode(purpose,purpose==='receiver-new'?newPhone.value:'',props.receiverId);if(active(run)){cooldown.value=60;message.success('验证码请求已受理，请查收短信')}}catch(e:any){if(active(run))message.error(e?.message || '短信未发送成功，请稍后重试')}finally{if(active(run))sending.value=''}
}
async function save(){
  if(busy.value || !validNewPhone.value || !/^\d{6}$/.test(currentCode.value) || !/^\d{6}$/.test(newCode.value))return
  const run=generation;saving.value=true
  try{const response=await saveOperationReceiver(newPhone.value,currentCode.value,newCode.value);if(active(run)){receiver.value=response.data || {};currentCode.value='';newCode.value='';emit('update:code','');window.dispatchEvent(new Event('platform-operation-receiver-changed'));message.success('备用号码已增加，超级管理员手机号仍保留')}}catch(e:any){if(active(run))message.error(e?.message || '接收号码未保存成功')}finally{if(active(run))saving.value=false}
}
watch(newPhone,()=>{newCode.value=''})
function changeReceiver(value:string){emit('update:receiverId',value);emit('update:code','');emit('changed')}
watch(()=>[store.getters.token,store.getters.userInfo?.id,store.getters.userInfo?.orgId].join(':'),()=>{generation++;receiver.value={};currentCode.value='';newCode.value='';newPhone.value='';emit('update:code','');sending.value='';saving.value=false;cooldown.value=0})
const timer=setInterval(()=>{if(cooldown.value>0)cooldown.value--},1000)
function receiverChanged(){loadSequence++;currentCode.value='';newCode.value='';emit('update:code','');emit('changed');void load()}
onMounted(()=>{void load();window.addEventListener('platform-operation-receiver-changed',receiverChanged)})
onBeforeUnmount(()=>{disposed=true;generation++;clearInterval(timer);window.removeEventListener('platform-operation-receiver-changed',receiverChanged)})

return (_ctx: any,_cache: any) => {
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_select_option = _resolveComponent("a-select-option")!
  const _component_a_select = _resolveComponent("a-select")!
  const _component_a_alert = _resolveComponent("a-alert")!
  const _component_a_input = _resolveComponent("a-input")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("p", null, [
      _createTextVNode("超级管理员："),
      _createElementVNode("strong", null, _toDisplayString(receiver.value.phone || '尚未读取'), 1),
      _createTextVNode("（始终保留）"),
      _createVNode(_component_a_button, {
        size: "small",
        type: "link",
        disabled: busy.value,
        onClick: load
      }, {
        default: _withCtx(() => [
          _createTextVNode("刷新")
        ]),
        _: 1
      }, 8, ["disabled"])
    ]),
    _createVNode(_component_a_select, {
      value: _ctx.receiverId,
      disabled: busy.value || !receiver.value.phone,
      "aria-label": "本次短信接收号码",
      style: {"width":"100%"},
      "onUpdate:value": changeReceiver
    }, {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(receiver.value.receivers || [], (item) => {
          return (_openBlock(), _createBlock(_component_a_select_option, {
            key: item.id,
            value: item.id
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(item.mandatory?'超级管理员':'备用号码') + " · " + _toDisplayString(item.phone), 1)
            ]),
            _: 2
          }, 1032, ["value"]))
        }), 128))
      ]),
      _: 1
    }, 8, ["value", "disabled"]),
    (error.value)
      ? (_openBlock(), _createBlock(_component_a_alert, {
          key: 0,
          type: "error",
          message: error.value,
          "show-icon": ""
        }, null, 8, ["message"]))
      : _createCommentVNode("", true),
    (_ctx.showCode)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(_component_a_input, {
            value: _ctx.code,
            maxlength: 6,
            inputmode: "numeric",
            autocomplete: "one-time-code",
            placeholder: "请输入6位短信验证码",
            "aria-label": "系统维护短信验证码",
            "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('update:code',$event)))
          }, null, 8, ["value"]),
          _createVNode(_component_a_button, {
            loading: sending.value===_ctx.purpose,
            disabled: busy.value || cooldown.value>0 || !receiver.value.phone,
            onClick: _cache[1] || (_cache[1] = ($event: any) => (send(_ctx.purpose)))
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(cooldown.value>0?cooldown.value+'秒后重发':'获取验证码'), 1)
            ]),
            _: 1
          }, 8, ["loading", "disabled"])
        ]))
      : _createCommentVNode("", true),
    (_ctx.showCode)
      ? (_openBlock(), _createElementBlock("p", _hoisted_3, "验证码5分钟内有效，仅用于本次维护操作；开启、关闭及保存文案均须验证。"))
      : _createCommentVNode("", true),
    _createElementVNode("details", null, [
      _hoisted_4,
      _hoisted_5,
      _createVNode(_component_a_input, {
        value: newPhone.value,
        "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((newPhone).value = $event)),
        maxlength: 11,
        inputmode: "tel",
        placeholder: "新的接收手机号",
        "aria-label": "新的接收手机号",
        disabled: busy.value
      }, null, 8, ["value", "disabled"]),
      _createElementVNode("div", _hoisted_6, [
        _createVNode(_component_a_input, {
          value: currentCode.value,
          "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((currentCode).value = $event)),
          maxlength: 6,
          inputmode: "numeric",
          placeholder: "超级管理员验证码",
          disabled: busy.value
        }, null, 8, ["value", "disabled"]),
        _createVNode(_component_a_button, {
          disabled: busy.value || cooldown.value>0 || !receiver.value.phone,
          onClick: _cache[4] || (_cache[4] = ($event: any) => (send('receiver-current')))
        }, {
          default: _withCtx(() => [
            _createTextVNode("验证超级管理员")
          ]),
          _: 1
        }, 8, ["disabled"])
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createVNode(_component_a_input, {
          value: newCode.value,
          "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => ((newCode).value = $event)),
          maxlength: 6,
          inputmode: "numeric",
          placeholder: "新接收号码验证码",
          disabled: busy.value
        }, null, 8, ["value", "disabled"]),
        _createVNode(_component_a_button, {
          disabled: busy.value || cooldown.value>0 || !validNewPhone.value,
          onClick: _cache[6] || (_cache[6] = ($event: any) => (send('receiver-new')))
        }, {
          default: _withCtx(() => [
            _createTextVNode("验证新接收号码")
          ]),
          _: 1
        }, 8, ["disabled"])
      ]),
      (cooldown.value>0)
        ? (_openBlock(), _createElementBlock("p", _hoisted_8, _toDisplayString(cooldown.value) + "秒后可再次获取验证码", 1))
        : _createCommentVNode("", true),
      _createVNode(_component_a_button, {
        type: "primary",
        loading: saving.value,
        disabled: busy.value || !validNewPhone.value || !/^\d{6}$/.test(currentCode.value) || !/^\d{6}$/.test(newCode.value),
        onClick: save
      }, {
        default: _withCtx(() => [
          _createTextVNode("增加备用号码")
        ]),
        _: 1
      }, 8, ["loading", "disabled"])
    ])
  ]))
}
}

})